import React from "react";
import { connect } from "react-redux";
import { GetCurrentStoreData, WebsitesState } from "../../store/websites/types";
import { getCurrentStoreData } from "../../store/websites/thunks";
import _ from "lodash";
import {
  removeSingleWebsitePageFromStore,
  saveWebsitesPagesInState,
  setPageLoadStatus,
  toggleWaitingForMovePageToAnotherWebsite,
} from "../../store/websitePages/actions";
import { movePageAsync } from "../../helpers/async/movePageAsync";
import { AuthState } from "../../store/auth/types";
import { WebsitePagesState } from "../../store/websitePages/types";
import { LoadStatus } from "../../enums/enums";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { openNotification } from "../../helpers/openNotification";
import {
  DEFAULT_ERROR_MESSAGE,
  DEFAULT_ERROR_TITLE,
  notificationDuration,
} from "../../data/constants";
import { getWebsiteInitialPagesLoadStatus } from "../../store/websitePages/thunks";
import { checkIsWebsitePublished } from "../../helpers/checkIsWebsitePublished";
import { formatImageUrl } from "../../helpers/strings/formatImageUrl";
import { CornerUpRight, Globe } from "lucide-react";
import { Button, Popover } from "antd";
import { getActiveDomain } from "../../helpers/websites/getActiveDomain";
import LoaderAnimated from "../dashboard/LoaderAnimated";
import SidebarButton from "./SidebarButton";

interface Props extends RouteComponentProps {
  isMovePopoverVisible: boolean;
  setIsMovePopoverVisible: (isMovePopoverVisible: boolean) => void;
  onVisibleChange: (isMovePopoverVisible: boolean) => void;
  page: any;
  children: React.ReactNode;
  placement: "top" | "bottom" | "left" | "right" | "topRight" | "topLeft";
  align?: any;

  websites: WebsitesState;
  auth: AuthState;
  websitesPages: WebsitePagesState;
  history: any;
  getCurrentStoreData: GetCurrentStoreData;
  toggleWaitingForMovePageToAnotherWebsite: any;
  setPageLoadStatus: any;
  saveWebsitesPagesInState: any;
  removeSingleWebsitePageFromStore: any;
  getWebsiteInitialPagesLoadStatus: any;
}
const MovePagePopover = (props: Props) => {
  const {
    websites,
    getCurrentStoreData,
    isMovePopoverVisible,
    setIsMovePopoverVisible,
    onVisibleChange,
    page,
    setPageLoadStatus,
    children,
    align,
  } = props;
  const { currentWebsite, currentWebsitePage } = getCurrentStoreData();
  const myOtherWebsites = websites.items.filter((website) => {
    return website.id !== _.get(currentWebsite, "id");
  });
  const currentPageWebsite = websites.items.find(
    (website) => website.id === page.website
  );

  const moveToItems = myOtherWebsites.map((website) => {
    const movePage = () => {
      setIsMovePopoverVisible(false);
      props.toggleWaitingForMovePageToAnotherWebsite(true);
      movePageAsync({
        accessToken: props.auth.accessToken,
        newWebsiteId: website.id,
        pageId: page.id,
        subdomain: currentPageWebsite.subdomain,
      })
        .then((response) => {
          props.setPageLoadStatus({
            pageId: page.id,
            status: LoadStatus.LOADED,
          });
          props.saveWebsitesPagesInState([response.data]);
          props.removeSingleWebsitePageFromStore({
            websiteId: currentPageWebsite.id,
            pageUrl: page.url,
          });
          if (currentWebsitePage === page) {
            props.history.push(`/${_.get(currentWebsite, "subdomain")}/pages`);
            window.scrollTo(0, 0);
          }
        })
        .catch((error) => {
          console.error(error.response);
          openNotification(
            DEFAULT_ERROR_TITLE,
            DEFAULT_ERROR_MESSAGE,
            "OK",
            "error",
            notificationDuration.medium
          );
        })
        .finally(() => {
          props.toggleWaitingForMovePageToAnotherWebsite(false);
        });
    };
    const getIcon = (website) => {
      if (!website) return null;
      const initialPagesStatus =
        props.getWebsiteInitialPagesLoadStatus(website);
      const isPublished =
        initialPagesStatus !== LoadStatus.LOADED
          ? website.is_published
          : checkIsWebsitePublished(website, props.websitesPages.items);
      const faviconUrl = _.get(website, "favicon_16x16_url");
      if (faviconUrl) {
        return (
          <img
            src={formatImageUrl(faviconUrl)}
            style={{
              width: "16px",
              height: "16px",
              objectFit: "contain",
              opacity: isPublished ? 1 : 0.25,
            }}
          />
        );
      }
      return <Globe size={16} />;
    };
    return (
      <SidebarButton
        key={website.id}
        disabled={props.websitesPages.isWaitingForMoveWebsitePageResponse}
        onClick={movePage}
        icon={getIcon(website)}
      >
        <span>{getActiveDomain(website)}</span>
      </SidebarButton>
    );
  });

  return (
    <Popover
      transitionName=""
      title="Move page to..."
      content={<div>{moveToItems}</div>}
      overlayStyle={{ position: "fixed" }}
      overlayClassName="nav-sidebar__move-to"
      trigger="click"
      placement={props.placement}
      visible={props.isMovePopoverVisible}
      onVisibleChange={props.onVisibleChange}
      align={props.align}
    >
      {children}
    </Popover>
  );
};

const mapStateToProps = (state: any) => {
  return {
    websites: state.websites,
    auth: state.auth,
    websitesPages: state.websitesPages,
  };
};

export default connect(mapStateToProps, {
  getCurrentStoreData,
  toggleWaitingForMovePageToAnotherWebsite,
  setPageLoadStatus,
  saveWebsitesPagesInState,
  removeSingleWebsitePageFromStore,
  getWebsiteInitialPagesLoadStatus,
})(withRouter(MovePagePopover));
